import { VerifierType, VerifyType } from 'src/Enum/EsgGreenhouse';
import {
  IGhGasEmissionVerifyFormValues,
  IGhGasEmissionVolumeFormValues,
  IPerformanceGhGasMgmtFormValues,
  IPerformanceGhGasMgmtReportFormValues,
} from '../EsgGreenhouseFormProvider/types';
import {
  checkMessageEn,
  validateSpace,
  validateSpaceTextInput,
} from '@Utils/validation';

export const checkPerformanceGhGasMgmtTh = (
  performanceGhGasMgmt: IPerformanceGhGasMgmtFormValues
): boolean => {
  const { result, descriptionTh } = performanceGhGasMgmt || {};

  if (!result) return false;

  if (result === VerifyType.YES) {
    if (!descriptionTh) return false;

    if (!validateSpace(descriptionTh)) {
      return false;
    }
  }

  return true;
};

export const checkPerformanceGhGasMgmtEn = (
  performanceGhGasMgmt: IPerformanceGhGasMgmtFormValues
): boolean => {
  const { result, descriptionEn } = performanceGhGasMgmt || {};

  if (!result) return false;

  if (result === VerifyType.YES) {
    if (!descriptionEn || !checkMessageEn(descriptionEn)) {
      return false;
    }

    if (!validateSpace(descriptionEn)) {
      return false;
    }
  }

  if (result === VerifyType.NO) {
    if (!checkMessageEn(descriptionEn || '')) {
      return false;
    }
  }

  return true;
};
export const checkPerfGhGasMgmtReportIntroRemarkEnValid = (
  performanceGhGasMgmtReport: IPerformanceGhGasMgmtReportFormValues
): boolean => {
  const { introduction, remark } = performanceGhGasMgmtReport || {};

  const { descriptionEn: introEn } = introduction || {};
  const { descriptionEn: remarkEn } = remark || {};

  if (!checkMessageEn(introEn || '')) {
    return false;
  }

  if (!checkMessageEn(remarkEn || '')) {
    return false;
  }

  return true;
};

export const checkPerfGhGasMgmtReportIntroSpaceValid = (
  performanceGhGasMgmtReport: IPerformanceGhGasMgmtReportFormValues,
  language: 'Th' | 'En'
) => {
  const { introduction } = performanceGhGasMgmtReport || {};

  const isIntroSpaceValid = validateSpace(
    introduction?.[`description${language}`]
  );

  return isIntroSpaceValid;
};

export const checkPerfGhGasMgmtReportRemarkSpaceValid = (
  performanceGhGasMgmtReport: IPerformanceGhGasMgmtReportFormValues,
  language: 'Th' | 'En'
) => {
  const { remark } = performanceGhGasMgmtReport || {};

  const isRemarkSpaceValid = validateSpaceTextInput(
    remark?.[`description${language}`]
  );

  return isRemarkSpaceValid;
};

export const checkPerfGhGasMgmtIntroSpaceValid = (
  performanceGhGasMgmt: IPerformanceGhGasMgmtFormValues,
  language: 'Th' | 'En'
) => {
  const { remark } = performanceGhGasMgmt || {};

  const isRemarkSpaceValid = validateSpaceTextInput(
    remark?.[`description${language}`]
  );

  return isRemarkSpaceValid;
};

export const checkPerfGhGasMgmtRemarkEnValid = (
  performanceGhGasMgmt: IPerformanceGhGasMgmtFormValues
): boolean => {
  const { remark } = performanceGhGasMgmt || {};

  if (!checkMessageEn(remark?.descriptionEn || '')) {
    return false;
  }

  return true;
};

const checkGhGasEmissionVerify = (
  ghGasEmissionVerify: IGhGasEmissionVerifyFormValues,
  otherNameField: 'otherNameTh' | 'otherNameEn'
): boolean => {
  const { verify, verifier } = ghGasEmissionVerify || {};
  if (!verify) return false;

  if (verify === VerifyType.YES) {
    if (verifier.infoCategoryMasterDataId === '') {
      return false;
    }

    if (
      verifier.infoCategoryMasterDataId === VerifierType.GHG_VERIFIER_OTHER_ID
    ) {
      if (
        verifier[otherNameField] === '' ||
        verifier[otherNameField] === undefined
      ) {
        return false;
      }
    }

    if (
      !checkMessageEn(verifier[otherNameField] || '') ||
      !validateSpaceTextInput(verifier[otherNameField])
    ) {
      return false;
    }
  }

  return true;
};

export const checkGhGasEmissionVerifyTh = (
  ghGasEmissionVerify: IGhGasEmissionVerifyFormValues
): boolean => {
  return checkGhGasEmissionVerify(ghGasEmissionVerify, 'otherNameTh');
};

export const checkGhGasEmissionVerifyEn = (
  ghGasEmissionVerify: IGhGasEmissionVerifyFormValues
): boolean => {
  return checkGhGasEmissionVerify(ghGasEmissionVerify, 'otherNameEn');
};

export const checkGhGasEmissionVerifySpaceValid = (
  ghGasEmissionVerify: IGhGasEmissionVerifyFormValues,
  language: 'Th' | 'En'
) => {
  const { remark } = ghGasEmissionVerify || {};

  const isRemarkSpaceValid = validateSpaceTextInput(
    remark?.[`description${language}`]
  );

  return isRemarkSpaceValid;
};

export const checkGhGasEmissionVerifyRemarkSpaceValid = (
  ghGasEmissionVerify: IGhGasEmissionVerifyFormValues,
  language: 'Th' | 'En'
) => {
  const { remark } = ghGasEmissionVerify || {};

  const isRemarkSpaceValid = validateSpaceTextInput(
    remark?.[`description${language}`]
  );

  return isRemarkSpaceValid;
};

export const checkGhGasEmissionVolumeRemarkEnValid = (
  ghGasEmissionVolume: IGhGasEmissionVolumeFormValues
): boolean => {
  const { remarkTotalGhGas, remarkScope1, remarkScope2, remarkScope3 } =
    ghGasEmissionVolume || {};

  if (!checkMessageEn(remarkTotalGhGas?.descriptionEn || '')) {
    return false;
  }

  if (!checkMessageEn(remarkScope1?.descriptionEn || '')) {
    return false;
  }

  if (!checkMessageEn(remarkScope2?.descriptionEn || '')) {
    return false;
  }

  if (!checkMessageEn(remarkScope3?.descriptionEn || '')) {
    return false;
  }

  return true;
};

export const checkGhGasEmissionVolumeRemarkSpaceValid = (
  ghGasEmissionVolume: IGhGasEmissionVolumeFormValues,
  language: 'Th' | 'En'
) => {
  const { remarkScope1, remarkScope2, remarkScope3, remarkTotalGhGas } =
    ghGasEmissionVolume || {};

  const isRemarkSpaceValid =
    validateSpaceTextInput(remarkScope1?.[`description${language}`]) &&
    validateSpaceTextInput(remarkScope2?.[`description${language}`]) &&
    validateSpaceTextInput(remarkScope3?.[`description${language}`]) &&
    validateSpaceTextInput(remarkTotalGhGas?.[`description${language}`]);

  return isRemarkSpaceValid;
};
